<template>
  <v-app-bar color="primary" dark app>
    <img :src="computeLogo" height="36" alt="Dr. Logic Services" class="mr-4" v-if="hideDrawer" />
    <v-app-bar-nav-icon @click="handleDrawerToggle" v-if="!hideDrawer" />
    <h3 class="pr-3">{{ $route.meta.title || '' }}</h3>
    <v-spacer />
    <v-toolbar-items>
      <v-menu
        v-if="isLoggedIn"
        offset-y
        origin="center center"
        :nudge-bottom="10"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon large text slot="activator" v-on="on">
            <v-avatar size="30px">
              <img :src="currentUser.avatar" alt="Dr. Logic" />
            </v-avatar>
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in items"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-item-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>
<script>
import Util from '@/util'

export default {
  name: 'AppToolbar',
  components: {},
  props: ['hideDrawer'],
  data() {
    return {
      currentUser: {
        avatar: 'static/drlogic-square-white.png',
      },
      isLoggedIn: false,
      items: [
        {
          icon: 'exit_to_app',
          href: '#',
          title: 'Logout',
          click: this.handleLogut,
        },
      ],
    }
  },
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav
    },
    computeLogo() {
      return 'static/drlogic-rect-white.png'
    },
  },
  methods: {
    handleDrawerToggle() {
      this.$emit('side-icon-click')
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    },
    handleLogut() {
      let vm = this
      this.$store.commit('setToken', null)
      this.$store.commit('setUserData', null)
      delete this.$api.defaults.headers.common['Authorization']
      this.$router
        .push({
          name: 'login',
        })
        .catch(error => {
          window.location.reload()
        })
    },
    handleSetting() {},
    handleProfile() {},
  },
  created() {},
  mounted() {
    let currentUser = this.$store.getters.getUserData
    this.isLoggedIn = this.$store.getters.getToken
    this.currentUser = Object.assign(this.currentUser, currentUser)
  }
}
</script>

<style lang="sass" scoped></style>
